import { render } from "./PageLoading.vue?vue&type=template&id=32aa8040&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=32aa8040&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1492509371/src/github.com/visitorscoverage/vc-code/vue/apps/benefit-estimator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aa8040"]])

export default __exports__